module.exports = __webpack_public_path__ + "img/011.694028b6.png";